<template>
    <v-app id="inspire">
      <warehouseExport />
    </v-app>
  </template>
  
  <script>
  // @ is an alias to /src
  import warehouseExport from "@/components/Warehouse/Export/c-warehouse-export-list.vue";
  
  export default {
    name: "Warehouse-Export",
    components: {
        warehouseExport,
    },
  };
  </script>
  